
import { Receipt, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const OCR_WEBSITE = "https://exiptrack-ocr.vercel.app/";

const ReceiptOCRTab = () => {
  const handleRedirect = () => {
    window.open(OCR_WEBSITE, "_blank");
  };

  return (
    <div className="flex flex-col items-center justify-center py-8 space-y-4">
      <div className="text-center max-w-md">
        <h3 className="text-lg font-medium mb-2">Receipt Scanner</h3>
        <p className="text-sm text-gray-600 mb-4">
          Our receipt scanning functionality is now available on a dedicated website for improved performance and reliability.
        </p>
        <Button 
          onClick={handleRedirect}
          className="bg-emerald-600 hover:bg-emerald-700 w-full"
        >
          <Receipt className="mr-2 h-4 w-4" />
          Open Receipt Scanner
        </Button>
        <p className="text-xs text-gray-500 mt-3">
          You will be redirected to our secure receipt scanning website.
        </p>
      </div>
    </div>
  );
};

export default ReceiptOCRTab;
